module.exports = __webpack_public_path__ + "media/images/fr_ca/welcome_leadership-76a4861d22f8972e76e93736a5f66b0d.png";